// 引入 MDF Biz Action 层：把单据业务动作注册为 ttx.command 命令
import '../tx/tx.biz';

const voucher = (function (params) {
    return {
        /**
         * 初始化单据 ViewModel
         *
         * @param {string} billNo      单据号（来自路由 billno）
         * @param {object} params       路由参数 { mode, query, busiObj, ... }
         * @param {function} viewCallback  回调 (vm, meta, title) 传给 Transfer 渲染页面
         * @param {function} asyncCallback 预留
         */
        init: async function (billNo, params, viewCallback, asyncCallback) {
            console.log(params.query, 'params-------------------888888888');
            let load = ttx.loading.showInCurrentTab()
            // 错误兜底：loading.hide 幂等，重复调用安全。
            // 任何失败路径（meta 加载失败 / 回调内同步异常 / 接口报错）都必须隐藏 loading，否则页面永久卡死
            var _hideLoad = function () { try { load.hide(); } catch (e) {} };
            ttx.loader.createUIDOM({ id: params.query.metaid }, function (meta) {
                try {
                    _initWithMeta(billNo, params, viewCallback, meta, _hideLoad);
                } catch (err) {
                    ttx.log.error('[voucher] init 回调同步异常:', err);
                    _hideLoad();
                }
            }, function (err) {
                ttx.log.error('[voucher] init: meta 加载失败:', err);
                _hideLoad();
            });
        }
    }

    function _initWithMeta(billNo, params, viewCallback, meta, _hideLoad) {
        ttx.cache.metas.set(`${billNo}:${meta.id}`, meta);
        // 从 meta 补充 query 缺失的参数（拉单等场景只传了 metaid，后端接口需要 appCode/serviceCode）
        if (!params.query.appCode && meta.appCode) {
            params.query.appCode = meta.appCode;
        }
        if (!params.query.serviceCode && meta.serviceCode) {
            params.query.serviceCode = meta.serviceCode;
        }
        let model = new ttx.models.ContainerModel(meta)
        // 关联 MDF Biz Action 层，支持 viewmodel.biz.do('save', vm, params) 调用
        model.biz = ttx.biz;
        model._set_data('params', params, true);
        // 缓存 billType（_getBillType 优先读 cache，避免 template.type 与 meta.type 不一致导致误判）
        model.setCache('billType', meta.type === 1 ? 'voucherlist' : 'voucher');
        // 提前设好 layoutType，避免首帧闪烁（原在 Meta.componentDidMount 中设置）
        model.setCache('layoutType', (meta.view || meta.template?.view)?.layoutType);
        // 是否启用审批（主实体 is_approval=1）：卡片/列表据此展示「审批流」按钮
        model.setCache('isApproval', Number(meta.isApproval) === 1);
        // SDK 层：模型驱动，调用 setViewMeta 为所有控件创建对应的 ViewModel
        model.setViewMeta(meta.view || meta.template?.view);
        // 初始化当前模式：新增和编辑态均可编辑，其他默认浏览态
        var initMode = params.mode === 'add' ? 'edit' : (params.mode === 'edit' ? 'edit' : 'browse');
        // 列表页不需要模式状态，仅卡片详情页需要
        if (meta.type !== 1) {
            model._set_data?.('currentMode', initMode, true);
            // 存储原始 mode（add/edit/browse），用于按钮 visibleModes 过滤判断页面状态
            model._set_data?.('pageMode', params.mode || 'browse', true);
            // 触发 modeChange 通知所有监听器（GroupContainer/ToolBar/List 等 forceUpdate）
            model.execute('modeChange', initMode);
        }

        // billno 优先级：路由参数 > meta.serviceCode（即 bizObject code）
        var actualBillno = billNo || meta.serviceCode || '';
        // meta.type: 1-列表 2-详情(card) 3-联查 4-模态框
        var metaType = meta.type;

        // ========================================================
        // 列表页：加载分页数据（新增模式跳过）
        // ========================================================
        if (metaType === 1 && actualBillno && params.mode !== 'add') {
            var _pageSize = 20;
            var _pageNum = 1;
            // 提取加载逻辑为公共函数，back 事件复用
            var _loadList = function (pageNum, cb) {
                ttx.bill.list(null, { billno: actualBillno }, { params: params, pageSize: _pageSize, pageNum: pageNum }, function (res) {
                    if (res && res.data && (res.data.list || res.data.data)) {
                        var list = res.data.list || res.data.data;
                        // 兼容命名空间格式：若当前 value 已是按编码隔离的对象，写入对应的表格 key，避免覆盖其他组件数据
                        var curValue = model._get_data('value');
                        if (curValue && typeof curValue === 'object' && !Array.isArray(curValue)) {
                            var tableKey = null;
                            for (var k in curValue) {
                                if (curValue.hasOwnProperty(k) && Array.isArray(curValue[k])) {
                                    tableKey = k;
                                    break;
                                }
                            }
                            if (tableKey) {
                                var updated = {};
                                updated[tableKey] = list;
                                model._set_data('value', Object.assign({}, curValue, updated), true);
                            } else {
                                model._set_data('value', list, true);
                            }
                        } else {
                            model._set_data('value', list, true);
                        }
                        model.setCache('pagination', { current: pageNum, pageSize: _pageSize, total: res.data.total || 0 });
                        if (ttx.formula && model._scheduleFormulas) {
                            model._scheduleFormulas('*');
                        }
                    }
                    // 记录首屏数据加载时间：Search 挂载后的 autoSearch 据此判断是否可以跳过重复查询
                    model.setCache('initialListLoadedAt', Date.now());
                    model.execute('dataRefresh');
                    _hideLoad();
                    cb && cb();
                });
            };
            // 从卡片页返回时刷新到第 1 页
            model.on('back', function () { _loadList(1); });
            _loadList(_pageNum, function () { viewCallback(model, meta, meta.title); });
        }
        // ========================================================
        // 卡片详情页：加载单条记录（编辑/查看模式）
        // ========================================================
        else if (metaType === 2 && params.mode !== 'add' && params.query.id && actualBillno) {
            console.log('需要设置数据');

            ttx.bill.detail(null, { billno: actualBillno }, { id: params.query.id }, function (res) {
                if (res && res.data) {
                    console.log(res.data, '请求数据');

                    model._set_data('value', res.data, true);
                    if (ttx.formula && model._scheduleFormulas) {
                        console.log('[FORMULA] voucher.init 数据加载后重算公式');
                        model._scheduleFormulas('*');
                    }
                }
                _hideLoad()
                viewCallback(model, meta, meta.title);
                // 组件挂载后再通知数据就绪，确保 BillHeadInfo 等已注册监听
                setTimeout(function () { model.execute('dataRefresh'); }, 0);
            });
        }
        // ========================================================
        // 新增模式 / 其他
        //
        // 新增时通过 ttx.codeRule 自动生成编码，存入 model cache。
        // Form 挂载后 _setFormData 检测到 _generatedCode，自动注入到表单 code 字段。
        // ========================================================
        else {
            // 新增态：把「打开页面」传入的 query / carryData 中的业务字段作为表单默认值。
            // 业务场景：客户数据池行点「加微信」「写跟进」→ 打开对应卡片的新增态，
            //   命令只带 query.pool_id（数据池行 id），这里把它赋值到卡片表单的 pool_id 隐藏字段，
            //   保存后「加微信记录 / 跟进记录」才能通过 pool_id 关联回数据池行并找到对应客户。
            // 优先级：carryData（显式覆盖）> query（常规页面参数）。
            if (params.mode === 'add') {
                var presetRaw = Object.assign({}, params.query || {}, params.carryData || {});
                // 排除框架级参数，避免污染业务数据
                ['metaid', 'appCode', 'serviceCode', 'id', 'pageNum', 'pageSize', 'mode', 'title'].forEach(function (k) {
                    delete presetRaw[k];
                });
                if (Object.keys(presetRaw).length) {
                    // 找到首个 Form 容器的 code，表单数据可能按容器编码命名空间存放
                    var presetFormCode = '';
                    var presetControls = (meta.view || meta.template?.view)?.containers || [];
                    var findFormCode = function (list) {
                        for (var i = 0; i < list.length && !presetFormCode; i++) {
                            var ctrl = list[i];
                            if (ctrl.cControlType === 'form' && ctrl.code) presetFormCode = ctrl.code;
                            if (ctrl.containers) findFormCode(ctrl.containers);
                        }
                    };
                    findFormCode(presetControls);

                    var presetValue = model._get_data('value') || {};
                    if (!presetValue || typeof presetValue !== 'object') presetValue = {};
                    if (presetFormCode) {
                        presetValue[presetFormCode] = Object.assign({}, presetRaw, presetValue[presetFormCode] || {});
                    } else {
                        Object.assign(presetValue, presetRaw);
                    }
                    model._set_data('value', presetValue, true);

                    // 逐个同步字段模型（k 为传入的动态字段名，非固定字段），保证 vm.get(字段).getValue() 可读取
                    Object.keys(presetRaw).forEach(function (k) {
                        var fieldModel = model.get?.(k);
                        if (fieldModel && typeof fieldModel._set_data === 'function') {
                            fieldModel._set_data('value', presetRaw[k], true);
                        }
                    });
                }
            }
            if (params.mode === 'add' && meta.serviceCode) {
                console.log('[voucher] 新增模式, serviceCode:', meta.serviceCode, '- 开始检查编码规则');
                // 步骤1: 检查该实体是否启用了编码规则
                ttx.codeRule.isEnabled(meta.serviceCode, function (checkRes) {
                    console.log('[voucher] isEnabled 结果:', checkRes);
                    if (checkRes && checkRes.enabled) {
                        // 步骤2: 调用后端生成编码（前缀+日期+序号）
                        ttx.codeRule.generate(meta.serviceCode, function (result) {
                            console.log('[voucher] generate 结果:', result);
                            if (result && result.code) {
                                // 步骤3: 从 meta 找到首个 Form 容器的 code (formCode)
                                var formCode = '';
                                var controls = (meta.view || meta.template?.view)?.controls || [];
                                for (var i = 0; i < controls.length && !formCode; i++) {
                                    var ctrl = controls[i];
                                    if (ctrl.cControlType === 'form') formCode = ctrl.code || '';
                                    if (ctrl.cControlType === 'groupcontainer' && ctrl.controls) {
                                        for (var j = 0; j < ctrl.controls.length && !formCode; j++) {
                                            if (ctrl.controls[j].cControlType === 'form') formCode = ctrl.controls[j].code || '';
                                        }
                                    }
                                }
                                console.log('[voucher] formCode:', formCode);

                                // 步骤4: 写入 model，区分命名空间/扁平结构
                                var curValue = model._get_data('value') || {};
                                if (formCode) {
                                    if (!curValue[formCode]) curValue[formCode] = {};
                                    curValue[formCode].code = result.code;
                                } else {
                                    curValue.code = result.code;
                                }
                                model._set_data('value', curValue, true);

                                // 步骤5: 同步到 code 字段的 SimpleModel，确保 vm.get('code').getValue() 可读取
                                var codeFieldModel = model.get?.('code');
                                if (codeFieldModel && typeof codeFieldModel._set_data === 'function') {
                                    codeFieldModel._set_data('value', result.code, true);
                                }
                            }
                            _hideLoad();
                            viewCallback(model, meta, meta.title);
                            setTimeout(function () { model.execute('dataRefresh'); }, 0);
                        });
                    } else {
                        console.log('[voucher] 编码规则未启用，直接渲染');
                        _hideLoad();
                        viewCallback(model, meta, meta.title);
                        setTimeout(function () { model.execute('dataRefresh'); }, 0);
                    }
                });
            } else {
                _hideLoad();
                viewCallback(model, meta, meta.title);
                setTimeout(function () { model.execute('dataRefresh'); }, 0);
            }
        }
    }
})()
export default voucher
